import { MainPropertyType } from '@aloft/toolkit-shared';
import { Block, Typography } from '@aloft/toolkit-sui';

import { IndicatedValue } from '../../components/IndicatedValue.tsx';
import { selectSubjectPropertyType } from '../../redux/features/selectors/selectSubjectPropertyType.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { COMMENTARY_TEXT } from '../commentary/consts.ts';
import { CostApproachDataSources } from './CostApproachDataSources.tsx';
import { CostApproachTable } from './CostApproachTable.tsx';
import { ManufacturedCostApproachTable } from './ManufacturedCostApproachTable/ManufacturedCostApproachTable.tsx';

import './CostApproachModule.scss';

const propertyTypeToTable: Record<MainPropertyType, () => React.ReactNode> = {
  singleFamilyResidence: CostApproachTable,
  manufacturedHome: ManufacturedCostApproachTable,
  multiFamily: CostApproachTable,
  townhouse: CostApproachTable,
};

export const CostApproachModule = () => {
  const propertyType = useAppSelector(selectSubjectPropertyType);
  const Table = propertyType ? propertyTypeToTable[propertyType] : CostApproachTable;

  return (
    <Block
      className="cost-approach-module-container"
      height="100%"
      width="100%"
      paddingLeft="1.5rem"
      overflow="auto"
    >
      <Block marginBottom=".5rem">
        <IndicatedValue />
      </Block>
      <Typography variant="h1">{COMMENTARY_TEXT['cost-approach'].title}</Typography>
      <Typography variant="body1">{COMMENTARY_TEXT['cost-approach'].subtitle}</Typography>
      <Table />
      <CostApproachDataSources propertyType={propertyType} />
    </Block>
  );
};
